import { createSelector } from '@reduxjs/toolkit';
import { messages } from 'locales';
import { LOCALE_TYPE } from 'locales/locale';
import { RootState } from 'redux/store';
import { UserReadState } from './user-read.slice';

const selectSelf = (state: RootState) => state;
const getUserReadState = createSelector(selectSelf, (state) => state.userRead);

const getLoaded = createSelector(
  getUserReadState,
  (state: UserReadState) => state.loaded,
);

const getUser = createSelector(
  getUserReadState,
  (state: UserReadState) => state.entity,
);

// 多言語文言設定のためのロケール
const getLocale = createSelector(
  getUserReadState,
  (state: UserReadState) => {
    if (messages[state.entity.locale] === undefined) {
      return messages[LOCALE_TYPE.EN] ? LOCALE_TYPE.EN : LOCALE_TYPE.JA;
    }
    return state.entity.locale;
  },
);

// UIに表示のためのロケール
const getDisplayLocale = createSelector(
  getUserReadState,
  (state: UserReadState) => state.entity.locale,
);

const getUserName = createSelector(
  getUserReadState,
  (state: UserReadState) => {
    const userNameJa = state.entity.given_name && state.entity.family_name
      ? `${state.entity.family_name} ${state.entity.given_name}`
      : '';
    const userNameEn = !state.entity.family_name_en
      ? userNameJa
      : `${state.entity.given_name_en} ${state.entity.family_name_en}`;
    switch (state.entity.locale) {
      case 'ja': {
        return userNameJa;
      }
      case 'en':
      default: {
        return userNameEn;
      }
    }
  },
);

const getLoggedIn = createSelector(
  getUserReadState,
  (state: UserReadState) => !!state.accessToken,
);

const getIdToken = createSelector(
  getUserReadState,
  (state: UserReadState) => state.idToken,
);

const getrRefreshToken = createSelector(
  getUserReadState,
  (state: UserReadState) => state.refreshToken,
);

const getrRefreshInterval = createSelector(
  getUserReadState,
  (state: UserReadState) => state.refreshInterval,
);

const isProjectInvitationServiceAuth = createSelector(
  getUserReadState,
  (state: UserReadState) => state.entity.access_points.includes('PJ_INVITE'),
);
const isGroupManagerServiceAuth = createSelector(
  getUserReadState,
  (state: UserReadState) => state.entity.access_points.includes('GROUP'),
);

const getCompanyName = createSelector(
  getUserReadState,
  (state: UserReadState) => {
    switch (state.entity.locale) {
      case 'ja': {
        return state.entity.company_name;
      }
      case 'en':
      default: {
        return state.entity.company_name_en || state.entity.company_name;
      }
    }
  },
);

export const userReadQuery = {
  getLoaded,
  getUser,
  getLocale,
  getDisplayLocale,
  getUserName,
  getLoggedIn,
  getrRefreshToken,
  getrRefreshInterval,
  getIdToken,
  isProjectInvitationServiceAuth,
  isGroupManagerServiceAuth,
  getCompanyName,
};
